module.exports = __webpack_public_path__ + "img/up_btn.01591a99.svg";